module.exports = __webpack_public_path__ + "static/media/icon-128.23da6b42.png";